import { createAction, props, union } from "@ngrx/store";
import { StackLocationGetGetQueryI } from "src/app/api/stack-location-get/stack-location-get.query.int";
import { StackLocationGetI } from "src/app/api/stack-location-get/stack-location-get.result.int";

export const error = createAction('[Stack Location] Error', props<{ messageText: string }>());
export const load = createAction('[Stack Location] Get', props<{
  query: StackLocationGetGetQueryI
}>());
export const received = createAction('Stack Location] Received', props<{
  result: StackLocationGetI
}>());
export const reset = createAction('[Stack Location] Reset', props<Record<string, unknown>>());

const all = union({
    error,
    load,
    received,
    reset,
});
export type Actions = typeof all;
